module.exports = __webpack_public_path__ + "img/colours-factory-logo.11e75ed2.svg";